export const modelTypes = [
    "CUISINE",
    "DISHES",
    "AWARD-WINNING",
    "ACCESSIBILITY",
    "PRICE",
    "SEATING-OPTIONS",
    "TYPE",
];

export const TABLE_UPDATE = "PREDEFINED_LISTS/TABLE_UPDATE";
export const FETCH_SUCCESS = "PREDEFINED_LISTS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "PREDEFINED_LISTS/DESTROY_FAILED",
    DESTROY_REQUEST: "PREDEFINED_LISTS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "PREDEFINED_LISTS/DESTROY_SUCCESS",

    FETCH_FAILED: "PREDEFINED_LISTS/FETCH_FAILED",
    FETCH_REQUEST: "PREDEFINED_LISTS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "PREDEFINED_LISTS/GET_FAILED",
    GET_REQUEST: "PREDEFINED_LISTS/GET_REQUEST",
    GET_SUCCESS: "PREDEFINED_LISTS/GET_SUCCESS",

    PATCH_FAILED: "PREDEFINED_LISTS/PATCH_FAILED",
    PATCH_REQUEST: "PREDEFINED_LISTS/PATCH_REQUEST",
    PATCH_SUCCESS: "PREDEFINED_LISTS/PATCH_SUCCESS",

    STORE_FAILED: "PREDEFINED_LISTS/STORE_FAILED",
    STORE_REQUEST: "PREDEFINED_LISTS/STORE_REQUEST",
    STORE_SUCCESS: "PREDEFINED_LISTS/STORE_SUCCESS",

    UPDATE_FAILED: "PREDEFINED_LISTS/UPDATE_FAILED",
    UPDATE_REQUEST: "PREDEFINED_LISTS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "PREDEFINED_LISTS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
